import { Injector } from '@angular/core';
import {
  FormioCustomComponentInfo,
  registerCustomFormioComponent,
} from 'angular-formio';
import { HeartlandPaymentComponent } from './payment-forms/heartland-payment/heartland-payment.component';
import { RecaptchaV3Component } from './recaptcha/recaptcha-v3/recaptcha-v3.component';
import { ProductFieldComponent } from './product-field/product-field.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { SingleProductFieldComponent } from './single-product-field/single-product-field.component';
import { HeartlandTokenizerComponent } from 'src/app/formiobuilder/components/custom-builder-components/heartland-tokenizer/heartland-tokenizer.component';
import { CommercialLineItemComponent } from 'src/app/formiobuilder/components/custom-builder-components/commercial-line-item/commercial-line-item.component';

const HEARTLAND_PAYMENT_COMPONENT_OPTIONS: FormioCustomComponentInfo = {
  type: 'heartlandpayment',
  selector: 'heartland-payment',
  title: 'Payment System',
  group: 'customComponents',
  icon: 'credit-card',
};

const HEARTLAND_PAYMENT_TOKENIZER_COMPONENT_OPTIONS: FormioCustomComponentInfo =
  {
    type: 'heartlandpaymenttokenizer',
    selector: 'heartland-payment-tokenizer',
    title: 'Heartland Tokenizer',
    group: 'customComponents',
    icon: 'credit-card',
  };

const RECAPTCHA_V3_COMPONENT_OPTIONS: FormioCustomComponentInfo = {
  type: 'recaptcha-v3',
  selector: 'recaptcha-v3',
  title: 'Captcha',
  group: 'advanced',
  icon: 'refresh',
};

const SUBSCRIPTION_PARENT_COMPONENT_OPTIONS: FormioCustomComponentInfo = {
  type: 'subscriptionPlans',
  selector: 'subscription-plans',
  title: 'Subscription Form',
  group: 'customComponents',
  icon: 'credit-card',
  schema: {
    label: 'subscriptionPlans',
    hideLabel: true,
    key: 'subscriptionPlans',
    customClass: 'subscription-plan-label',
  },
};

const PRODUCT_FIELD_COMPONENT_OPTIONS: FormioCustomComponentInfo = {
  type: 'productfield',
  selector: 'product-field',
  title: 'Multiple Product',
  group: 'customComponents',
  icon: 'fas fa-tags',
  schema: {
    label: 'productfield',
    hideLabel: true,
    key: 'productfield',
  },
};

const SINGLE_PRODUCT_FIELD_COMPONENT_OPTIONS: FormioCustomComponentInfo = {
  type: 'singleproduct',
  selector: 'single-product',
  title: 'Single Product',
  group: 'customComponents',
  icon: 'fas fa-tags',
  schema: {
    //label:'singleproduct',
    hideLabel: true,
    key: 'singleproduct',
  },
};

const TERMS_CONDITION_COMPONENT_OPTIONS: FormioCustomComponentInfo = {
  type: 'termscondition',
  selector: 'terms-condition',
  title: 'Terms and Condition',
  group: 'customComponents',
  icon: 'check-circle',
  schema: {
    label: 'termscondition',
    hideLabel: true,
    key: 'termscondition',
  },
};

const COMMERCIAL_LINE_ITEM: FormioCustomComponentInfo = {
  type: 'commercialLineItem',
  selector: 'commercial-line-item',
  title: 'Level II / Level III Item',
  group: 'customComponents',
  icon: 'fa fa-shopping-cart',
};

export function registerCustomForms(injector: Injector) {
  registerCustomFormioComponent(
    SINGLE_PRODUCT_FIELD_COMPONENT_OPTIONS,
    SingleProductFieldComponent,
    injector
  );
  registerCustomFormioComponent(
    PRODUCT_FIELD_COMPONENT_OPTIONS,
    ProductFieldComponent,
    injector
  );
  registerCustomFormioComponent(
    TERMS_CONDITION_COMPONENT_OPTIONS,
    TermsConditionComponent,
    injector
  );
  registerCustomFormioComponent(
    HEARTLAND_PAYMENT_COMPONENT_OPTIONS,
    HeartlandPaymentComponent,
    injector
  );

  registerCustomFormioComponent(
    HEARTLAND_PAYMENT_TOKENIZER_COMPONENT_OPTIONS,
    HeartlandTokenizerComponent,
    injector
  );
  registerCustomFormioComponent(
    RECAPTCHA_V3_COMPONENT_OPTIONS,
    RecaptchaV3Component,
    injector
  );
  registerCustomFormioComponent(
    COMMERCIAL_LINE_ITEM,
    CommercialLineItemComponent,
    injector
  );

  // if (!customElements.get('subscription-plans')) {
  //   registerCustomFormioComponent(
  //     SUBSCRIPTION_PARENT_COMPONENT_OPTIONS,
  //     SubscriptionParentComponent,
  //     injector
  //   );
  // }
}
